import { Card } from "@veneer/core";
import React from "react";
import { CourseCard } from "../cards/CourseCard";
import { NoItems } from "../common/NoItems";

//CourseDto
interface CourseTabContentProps {
  loading: boolean;
  emptyMessage: string;
  courses: any[];
  onOpenCourse: (courseID: number, isReinforcement: boolean) => void;
  imagesLoaded: boolean;
  getImageUrl: (courseID: number) => string;
  formatDate: (date: string) => string;
  t: (key: string) => string;
}

export const CourseTabContent: React.FC<CourseTabContentProps> = ({
  loading,
  emptyMessage,
  courses,
  onOpenCourse,
  imagesLoaded,
  getImageUrl,
  formatDate,
  t,
}) => {
  return (
    <>
      <Card
        appearance="outlined"
        className="coursesCard"
        content={
          <div>
            {loading ? (
              <div className="customNoItems">{t("header.loadingCourses")}</div>
            ) : courses.length > 0 ? (
              courses.map((course, index) => (
                <CourseCard
                  key={course.courseID ?? index}
                  course={course}
                  imagesLoaded={imagesLoaded}
                  imageUrl={getImageUrl(course.courseID)}
                  onClick={onOpenCourse}
                  formatDate={formatDate}
                  t={t}
                />
              ))
            ) : (
              <NoItems text={emptyMessage} />
            )}
          </div>
        }
      />
    </>
  );
};
